export * from "./TaxBaseVariableDto.interface";
export * from "./TaxBaseVariableFormState.interface";
export * from "./TaxBaseVariableParams.interface";
